export default "__VITE_ASSET__BoVUg93T__"